export var actionKey = '@@HISTORY';
export var reduxKey = '@@HISTORY';
//# sourceMappingURL=constants.js.map